export const getStringFromUnkownError = (error: unknown) => {
  try {
    if (typeof error === 'string') {
      return error;
    }
    if (error instanceof String) {
      return error.valueOf();
    }
    if (error instanceof Error) {
      const errorKeys = ['message', 'name', 'stack'];
      return JSON.stringify(error, errorKeys);
    }
    if (error instanceof Object) {
      return JSON.stringify(error, Object.getOwnPropertyNames(error));
    } else {
      return JSON.stringify(error);
    }
  } catch (_e) {
    return 'UNKNOWN ERROR';
  }
};
